export default __webpack_public_path__ + "static/media/480_dummy2016-klempner01-mobile-de.1b39048b.png";